import { gql } from '@apollo/client'

export const Query = gql`
  query Venues($companyId: ID!, $filters: VenueFilters, $order: VenueOrder, $after: String, $before: String, $first: Int, $last: Int) {
    venues(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        events {
          id
        }
        address
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
